import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { ReportesComponent } from './reportes/reportes.component';
import { authGuardSubmodule } from '../../auth/auth.guard';

const routes: Routes = [{
  path: 'app/reportes-normativos',
  component: ContenedorComponent,
  children: [
    {path: 'reportes', component: ReportesComponent, canActivate: [authGuardSubmodule]},
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportesNormativosRoutingModule { }
